import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UserBehaviourComponent } from './user-behaviour.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { AddEditUserDialogComponent } from './dailogs/add-edit-user-dialog/add-edit-user-dialog.component';
import { HealthCheckComponent } from './health/health-check.component';
import { CameraViewComponent } from './cam-view/camera-view-component';
import { VideoComponent } from './buffering/video.component';
import { VideoProgressComponent } from './buffering/video-progress.component';
import { EventNewTimelineComponent } from './event-timeline/event-timeline.component';
import { CameraMappingComponent } from './camera-mapping/camera-mapping.component';
import { NewTipsComponent } from './new-tips/new-tips.component';
import { ArchiveDashboardComponent } from './archive-dashboard/archive-dashboard.component';
import { SummaryDetailsPageComponent } from './summary-details-page/summary-details-page.component';


const routes: Routes = [
  { path: 'logs', component: UserBehaviourComponent },
  { path: 'user-management',component: UserManagementComponent},
  { path: 'health', component: HealthCheckComponent},
  { path: 'motion', component: CameraViewComponent},
  { path: 'events', component: EventNewTimelineComponent},
  { path: 'video', component: VideoComponent},
  { path: 'video1', component: VideoProgressComponent},
  { path: 'user-management/user',component: AddEditUserDialogComponent},
  { path: 'user-management/user/:id',component: AddEditUserDialogComponent},
  { path: 'user-management/camera-mapping', component: CameraMappingComponent},
  { path: 'new-tips', component: NewTipsComponent},
  { path: 'archive-dashboard', component: ArchiveDashboardComponent },
  { path: 'summary-details/:id', component: SummaryDetailsPageComponent },
  // Add more routes here
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class UserBehaviourRoutingModule { }
